import { useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import moment from 'moment';
import { useRef } from 'react';

const LS_KEYS = ['apc_user_id', 'apc_local_id', 'apc_session'];

// Prevents the error fixed in #28949 (First time of the day login fails)
const checkLocalStorage = () => {
  let session = localStorage?.getItem('apc_session');

  if (session) {
    session = JSON.parse(session);

    const timeNow = moment();
    const expiration = moment(session?.timestamp + session?.duration);
    if (expiration.isValid() && (timeNow.diff(expiration, 'days') > 0 || timeNow.date() !== expiration.date())) {
      LS_KEYS.forEach((k) => localStorage?.removeItem(k));
    }
  }
};

export const useAppMsalAuthentication = () => {
  const lsCheckOk = useRef(false);

  if (!lsCheckOk.current) {
    lsCheckOk.current = true;
    checkLocalStorage();
  }

  useMsalAuthentication(InteractionType.Redirect);
};